# N4 Payments

A Brazilian payment gateway with PrimeCash/Elysium-spec compatibility. Built for integrators who want
PIX, credit card, debit card, boleto, programmatic PIX-out, marketplace splits, and two-step
authorization in a single REST API — without per-provider integration headaches.

Under the hood N4 is an orchestrator: every payment is routed across a pool of provider accounts
(Mercado Pago today; Pagar.me, Asaas, PagBank, Efí Bank on the V1 roadmap). For integrators this is
opaque — you call one endpoint and get the same response shape regardless of which provider settled
the transaction.

## Base URL

```
https://api.n4-payments.com.br
```

All endpoints are JSON. Bodies are UTF-8. Timestamps are ISO 8601 UTC.

## Versioning

The public path is prefixed `/api/v1/`. Breaking changes get a new prefix; additive changes ship in
place and are noted in the [Changelog](/changelog).

## Quick path

```bash
# 1. Create a test transaction (PIX QR)
curl -u "$PUB:$SEC" \
  -H 'Content-Type: application/json' \
  -X POST https://api.n4-payments.com.br/api/v1/transactions \
  -d '{
    "amount": 1000,
    "paymentMethod": "pix",
    "customer": {"name": "Test", "email": "test@example.com"},
    "externalRef": "order-1",
    "postbackUrl": "https://webhook.site/your-id"
  }'

# Response includes pix.qrCode + qrCodeBase64 + expiresAt.
```

## What's next

- [Authentication](/authentication) — get your `pk_*` / `sk_*` API key pair
- [Test mode](/test-mode) — never hit a real provider while you build
- [Card tokenization](/tokenization) — keep raw card data out of your server (PCI SAQ-A)
- [Postbacks](/postbacks) — verify HMAC signatures + handle retries
- [Idempotency](/idempotency) — safely retry on network errors
- [API reference](/reference) — try every endpoint with your own keys
